/* Gallery browsing is independent of the chosen product; choosing pets updates both. */
class PortraitLanding extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.slides = [...this.querySelectorAll('[data-entry-slide]')];
    this.thumbs = [...this.querySelectorAll('[data-entry-thumb]')];
    this.index = 0;
    this.addEventListener('click', event => {
      const arrow = event.target.closest('[data-entry-direction]');
      const thumb = event.target.closest('[data-entry-thumb]');
      if (arrow) this.show(this.index + Number(arrow.dataset.entryDirection));
      if (thumb) this.show(Number(thumb.dataset.entryThumb));
    });
    this.addEventListener('change', event => {
      if (!event.target.matches('[data-entry-link]')) return;
      this.select(event.target);
    });
    const selected = this.querySelector('[data-entry-link]:checked');
    if (selected) this.select(selected);
  }
  show(index) {
    if (!this.slides.length) return;
    this.index = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
    this.thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === this.index)));
  }
  select(input) {
    this.show(Number(input.dataset.entryIndex));
    const price = this.querySelector('.entry-price');
    const priceTemplate = this.querySelector(`template[data-entry-price-index="${Number(input.dataset.entryIndex)}"]`);
    if (price && priceTemplate) price.replaceChildren(priceTemplate.content.cloneNode(true));
    const link = this.querySelector('[data-entry-next]');
    const url = input.dataset.entryLink;
    // Only a merchant-configured local product route can become the CTA destination.
    if (url && /^\/products\/[a-zA-Z0-9-]+(?:\?[^#]*)?$/.test(url)) {
      link.href = url;
      link.removeAttribute('aria-disabled');
      link.removeAttribute('tabindex');
    } else {
      link.removeAttribute('href');
      link.setAttribute('aria-disabled', 'true');
      link.setAttribute('tabindex', '-1');
    }
  }
}
if (!customElements.get('portrait-landing')) customElements.define('portrait-landing', PortraitLanding);
